import { render, staticRenderFns } from "./nextCoursesHome.vue?vue&type=template&id=ebf86a90&scoped=true"
import script from "./nextCoursesHome.vue?vue&type=script&lang=js"
export * from "./nextCoursesHome.vue?vue&type=script&lang=js"
import style0 from "./nextCoursesHome.vue?vue&type=style&index=0&id=ebf86a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf86a90",
  null
  
)

export default component.exports